import React from 'react';
import BaseHead from 'next/head';

import { MetaTags } from '@annunciate/web/dist/components/MetaTags';
import { Channel } from '@annunciate/core/dist/models';
import { usePageTitle } from '@annunciate/web/dist/hooks';

export interface HeadProps {
  title?: string;
  description?: string;
  image?: string;
  settings?: Channel['settings'];
}

// next is very particular about the `<title>` tag being a direct descendant of
// the <Head> element. So we wrap the `MetaTags` here to avoid issues.
export const Head: React.FC<HeadProps> = ({
  title,
  description,
  image,
  settings,
}) => {
  const pageTitle = usePageTitle(title, settings?.meta);

  return (
    <BaseHead>
      <title>{pageTitle}</title>
      <MetaTags
        title={title}
        description={description}
        image={image}
        settings={settings}
      />
    </BaseHead>
  )
}
